import React from "react";

function Education() {
  return (
    <>
      <h2 className="sec-head">Education</h2>
      <h4 className="edu-role">Bachelor of CA</h4>
      <p className="para-mar">
        AJK College of Arts & Science, Coimbatore, Tamilnadu, India
        <br />
        2018-2021
      </p>
      <h4 className="edu-role">Commerce With CA</h4>
      <p className="para-mar">
        HSS Ananganadi, Palakkad, Kerala, India
        <br />
        2015-2018
      </p>
    </>
  );
}

export default Education;
